module.exports = __webpack_public_path__ + "static/media/dislikeRed.de09ea1e.svg";